<template>
    <transition name="registerdialog">
        <div v-show="value" class="com-codics-hbb-order-register-dialog-body" @click="changeShow">
            <div class="com-codics-hbb-order-register-dialog-body-card" @click.stop="1">
                <div class="com-codics-hbb-order-register-dialog-body-header">
                    <span
                        class="iconfont com-codics-hbb-order-register-dialog-body-header-add">&#xe839;</span>&nbsp;&nbsp;填写资料创建
                    <div class="com-codics-hbb-order-register-dialog-body-header-close iconfont"
                        @click.stop="changeShow">
                        &#xe84a;</div>
                </div>
                <div class="com-codics-hbb-order-register-dialog-body-content">
                    <div class="com-codics-hbb-order-register-dialog-tip-card">
                        <div class="com-codics-hbb-order-register-dialog-tip-card-item"
                            v-for="(item, index) in tipsData" :key="index">
                            <div class="com-codics-hbb-order-register-dialog-tip-card-item-txt">
                                <span class="iconfont com-codics-hbb-order-register-dialog-body-header-add"
                                    v-html="item.icon"></span>&nbsp;&nbsp;{{ item.text }}
                            </div>
                        </div>
                    </div>
                    <el-input class="com-codics-hbb-order-register-dialog-input" v-model="registerForm.a" size="small"
                        placeholder="请输入用户邮箱地址..."></el-input>
                    <el-input class="com-codics-hbb-order-register-dialog-input" style="margin-left:15px;"
                        v-model="registerForm.n" size="small" placeholder="请输入用户姓名"></el-input>
                    <el-cascader class="com-codics-hbb-order-register-dialog-input" :options="roleData" clearable
                        v-model="rData" placeholder="请选择用户角色" size="small" style="margin-top:20px;margin-bottom: 50px;"
                        :props="{ value: 'id', label: 'role', checkStrictly: true, children: 'children' }"
                        @change="roleChange">
                    </el-cascader>
                    <div class="com-codics-hbb-order-register-dialog-btn iconfont" @click="registerAccount">&#xe6e9;
                        注册并发送</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { changeVerify, userLogin, listRole, registerAccount } from '@/api';
import { setCookie, setCookieWithExp } from '@/utils/mycookie';
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rData: [],
            roleData: [],
            registerForm: {
                a: '',
                n: '',
                r: null
            },
            qrImg: '',
            tipsData: [
                {
                    icon: '&#xe79c;',
                    text: '填写注册信息'
                },
                {
                    icon: '&#xe873;',
                    text: '分享注册链接'
                },
                {
                    icon: '&#xe849;',
                    text: '填写密码注册'
                },
            ]
        }
    },
    mounted() {
        this.listRoleFuc();
    },
    methods: {
        roleChange(a) {
            this.registerForm.r = a.length == 0 ? null : a[a.length - 1];
        },
        checkStringType(str) {
            const input = str.trim();
            if (/^1[3-9]\d{9}$/.test(input)) {
                return 'phone';
            } else if (/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(input)) {
                return 'email';
            }
            return null;
        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async registerAccount() {

            if (this.registerForm.a == '') {
                this.$message.error('请输入正确的手机号或邮箱!');
                return;
            }

            if (this.registerForm.n == '') {
                this.$message.error('请输入用户姓名!');
                return;
            }

            if (this.registerForm.r == null || this.registerForm.r == '') {
                this.$message.error('请选择用户角色!');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const type = this.checkStringType(this.registerForm.a);

            if (!type) {
                this.$message.error('请输入正确的手机号或邮箱');
                loading.close();
                return;
            }

            const data = await registerAccount({ type: type, ...this.registerForm });

            loading.close();

            if (data.code == 200) {

                this.$emit('input', !this.value);

                this.$message.success('注册消息发送成功！');

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        changeShow(e) {
            this.$emit('input', !this.value);
            e.stopPropagation();
            return false;
        }
    }
}
</script>

<style>
:root {
    --hbb-register-dialog-bg-color: #FFF;
    --hbb-register-dialog-header-add-color: #ea5b18;
    --hbb-register-dialog-font-color: #333;
    --hbb-register-dialog-font-tip-color: #AAA;
    --hbb-register-dialog-l-color: #F0F0F0;
    --hbb-register-dialog-card-bg-color: #FBFAF7;
    --hbb-register-dialog-card-btn-font-color: #FFF;
}

:root[data-theme="dark"] {
    --hbb-register-dialog-bg-color: #303030;
    --hbb-register-dialog-header-add-color: #ea5b18;
    --hbb-register-dialog-font-color: #FFFFFF;
    --hbb-register-dialog-font-tip-color: #555;
    --hbb-register-dialog-l-color: #3A3A3A;
    --hbb-register-dialog-card-bg-color: #404040;
    --hbb-register-dialog-card-btn-font-color: #FFF;
}

/* 弹窗体 */
.com-codics-hbb-order-register-dialog-body {
    height: 100%;
    width: 100%;
    transition: .3s;
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
}

.com-codics-hbb-order-register-dialog-body-card {
    height: 320px;
    width: 580px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
    background: var(--hbb-register-dialog-bg-color);
    border-radius: 8px;
    box-sizing: border-box;
    pointer-events: all;
}

.com-codics-hbb-order-register-dialog-body-header {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    border-bottom: 1px solid #F0F0F0;
    border-bottom: 1px solid var(--hbb-register-dialog-l-color);
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px !important;
    font-weight: bolder;
    color: #333;
    color: var(--hbb-register-dialog-font-color);
    padding-left: 20px;
}

.com-codics-hbb-order-register-dialog-body-header-add {
    color: var(--hbb-register-dialog-header-add-color);
    font-size: 12px;
}

.com-codics-hbb-order-register-dialog-body-header-close {
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 12px;
    cursor: pointer;
    color: #333;
    color: var(--hbb-register-dialog-font-color);
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-register-dialog-body-content {
    height: 280px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 30px;
    overflow: hidden;
}

.com-codics-hbb-order-register-dialog-tip-card {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 30px;
    background: #EEE;
    background: var(--hbb-register-dialog-card-bg-color);
    border-radius: 3px;
    margin-top: 20px;
    overflow: hidden;
}

.com-codics-hbb-order-register-dialog-tip-card::before {
    content: '';
    height: 1px;
    width: 66%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #F0F0F0;
    background: var(--hbb-register-dialog-header-add-color);
}

.com-codics-hbb-order-register-dialog-tip-card-item {
    height: 100%;
    width: 33.33333%;
    position: relative;
    float: left;
    box-sizing: border-box;
    text-align: center;
    color: #333;
    color: var(--hbb-register-dialog-font-color);
    line-height: 30px;
    font-size: 12px;
}

.com-codics-hbb-order-register-dialog-tip-card-item-txt {
    height: 100%;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 30px;
    text-align: center;
    font-size: 10px;
    background: #EEE;
    background: var(--hbb-register-dialog-card-bg-color);
    box-sizing: border-box;
    padding: 0 10px;
}

/* 定义进入和离开的过渡效果 */
.registerdialog-enter-active,
.registerdialog-leave-active {
    transition: .3s;
}

.registerdialog-enter,
.registerdialog-leave-to {
    opacity: 0;
}

.com-codics-hbb-order-register-dialog-input {
    width: calc(50% - 7.5px) !important;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-top: 20px;
    font-size: 10px !important;
}

.com-codics-hbb-order-register-dialog-input .el-input--small {
    font-size: 11px !important;
}

.com-codics-hbb-order-register-dialog-input .el-icon-arrow-down {
    font-size: 11px !important;
}

.com-codics-hbb-order-register-dialog-btn {
    height: 30px;
    width: fit-content;
    position: absolute;
    margin: auto;
    right: 30px;
    bottom: 30px;
    background: #ea5b18;
    background: var(--hbb-register-dialog-header-add-color);
    border-radius: 3px;
    line-height: 30px;
    font-size: 11px;
    line-height: 30px;
    text-align: center;
    color: #FFF;
    color: var(--hbb-register-dialog-card-btn-font-color);
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
    padding: 0 15px;
    box-sizing: border-box;
}

@media (max-width:768px) {}
</style>